import React, { useContext } from "react";
import "./index.css";
import {
	AudioOutlined,
	FileTextOutlined,
	FileWordOutlined,
	PictureOutlined,
	PlusCircleFilled,
	ToolOutlined,
	VideoCameraOutlined,
} from "@ant-design/icons";
// import UploadImageCard from "./UploadImageCard";
// import UploadTextCard from "./UploadTextCard";
import { Tooltip } from "antd";
import MyContext from "../Mycontext";

const ChooseCard = () => {
	const context = useContext(MyContext);
	if (!context) {
		return null; // 处理无法获取到 Context 的情况
	}
	const { requireType, setRequireType } = context;

	return (
		<div className="all-cards-wrapper">
			<div className="block">
				<div
					className={`upload-card-wrapper ${
						requireType === "text" ? "selected" : ""
					}`}
					onClick={() => {
						setRequireType && setRequireType("text");
					}}
				>
					<div className="icon-wrapper">
						<FileTextOutlined style={{ fontSize: "26px" }} />
					</div>

					<div className="title">文本数据</div>
				</div>
				<div
					className={`upload-card-wrapper ${
						requireType === "img" ? "selected" : ""
					}`}
					onClick={() => {
						setRequireType && setRequireType("img");
						// setUploadVisible(true);
					}}
				>
					<div className="icon-wrapper">
						<PictureOutlined style={{ fontSize: "26px" }} />
					</div>

					<div className="title">图片数据</div>
				</div>
			</div>
			<div className="block">
				<Tooltip
					title={() => {
						return (
							<>
								<ToolOutlined />
								<span style={{ marginLeft: 10 }}>正在开发中 ...</span>
							</>
						);
					}}
				>
					<div className="upload-card-wrapper disabled">
						<div className="icon-wrapper">
							<AudioOutlined style={{ fontSize: "26px" }} />
						</div>

						<div className="title">音频数据</div>
					</div>
				</Tooltip>
				<Tooltip
					title={() => {
						return (
							<>
								<ToolOutlined />
								<span style={{ marginLeft: 10 }}>正在开发中 ...</span>
							</>
						);
					}}
				>
					<div className="upload-card-wrapper disabled">
						<div className="icon-wrapper">
							<VideoCameraOutlined style={{ fontSize: "26px" }} />
						</div>

						<div className="title">视频数据</div>
					</div>
				</Tooltip>
			</div>
		</div>
	);
};

export default ChooseCard;
